import React, { useEffect, useState } from "react";
import classnames from "classnames";

import { CitySearchResultWithCateg } from "@vahak/core/dist/custom-types/location-search";
import SearchBlueIcon from "@vahak/core/dist/icons/SearchBlue.svg";
import GreyPlusIcon from "@vahak/core/dist/icons/GreyPlus.svg";
import CheckBlackIcon from "@vahak/core/dist/icons/CheckBlack.svg";
import EditBlueIcon from "@vahak/core/dist/icons/EditBlue.svg";
import CloseCircleIcon from "@vahak/core/dist/icons/CloseCircle.svg";

import MobileSearchCardStyles from "./MobileSearchCard.module.scss";
import QuickFilterPill, { QuickFilterPillProps } from "../quick-filter-pill/QuickFilterPill";
import CloseBtnStyles from "../CloseBtn.module.scss";
import Styles from "./MobileSearchCard.module.scss";

interface MobileSearchCardProps {
    nameSearchVal: string;
    onClearName?: () => void;
    sourceSearchLabelKey: (option: CitySearchResultWithCateg) => string;
    onClickSearchSource: React.DOMAttributes<HTMLDivElement>["onClick"];
    selectedSource?: CitySearchResultWithCateg;
    onClearSrc?: () => void;
    topDests: CitySearchResultWithCateg[];
    selectedDest?: CitySearchResultWithCateg;
    onClickDestQuickFilter: QuickFilterPillProps<CitySearchResultWithCateg>["onSelected"];
    onClickDestSearchBtn: () => void;
    onDeselectDestSearchBtn: () => void;
    isCardMinimized: boolean;
    onClickEdit: () => void;
    searchBy?: "location" | "name";
    className?: string;
}

const MobileSearchCard = ({
    nameSearchVal,
    onClearName,
    sourceSearchLabelKey,
    onClickSearchSource,
    selectedSource,
    onClearSrc,
    topDests,
    selectedDest,
    onClickDestQuickFilter,
    onClickDestSearchBtn,
    onDeselectDestSearchBtn,
    isCardMinimized,
    onClickEdit,
    searchBy,
    className
}: MobileSearchCardProps) => {
    const [isInEditMode, setIsInEditMode] = useState(false);

    // const onBlurDestinationSearch = useCallback(() => {
    //     if (!destinationSearchSelectedItem) {
    //         setDestSearchVisible(false);
    //         setDestSearchClear((state) => state + 1);
    //         // setDestSearchInputVal("");
    //     }
    // }, [destinationSearchSelectedItem]);

    const _onClearSrc = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        onClearSrc?.();
    };

    const _onClearName = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        onClearName?.();
    };

    useEffect(() => {
        setIsInEditMode(isCardMinimized && !!(selectedSource || selectedDest || nameSearchVal));
    }, [isCardMinimized, nameSearchVal, selectedSource, selectedDest]);

    return (
        <div className={classnames(className)}>
            <div
                className={classnames(
                    MobileSearchCardStyles.transporters__mobile_search__container,
                    isCardMinimized && MobileSearchCardStyles.minimized,
                    searchBy === "name" && MobileSearchCardStyles.minimized
                )}
            >
                <div
                    className={MobileSearchCardStyles.transporters__mobile_search__source_search_btn}
                    onClick={!isInEditMode ? (searchBy === "name" ? onClickEdit : onClickSearchSource) : undefined}
                >
                    {isInEditMode ? (
                        <div
                            className={classnames(
                                MobileSearchCardStyles.editContainer,
                                searchBy === "name" && MobileSearchCardStyles.nameEditContainer
                            )}
                            onClick={onClickEdit}
                        >
                            <div className={MobileSearchCardStyles.currentSelections}>
                                {searchBy === "location" && (
                                    <>
                                        <div className={MobileSearchCardStyles.selectedSrc}>
                                            {selectedSource
                                                ? sourceSearchLabelKey(selectedSource)
                                                : "Where is your Loading Point?"}
                                        </div>
                                        {selectedDest && (
                                            <div className={MobileSearchCardStyles.selectedDest}>
                                                Going towards {selectedDest.state}
                                            </div>
                                        )}
                                    </>
                                )}
                                {searchBy === "name" && (
                                    <div className={MobileSearchCardStyles.nameSearchVal__Container}>
                                        <SearchBlueIcon />{" "}
                                        <span className={MobileSearchCardStyles.nameSearch}>
                                            {nameSearchVal || "Search"}
                                        </span>
                                        {nameSearchVal && (
                                            <span
                                                className={CloseBtnStyles.btn}
                                                style={{ position: "absolute", right: "32px" }}
                                                onClick={_onClearName}
                                            >
                                                <CloseCircleIcon />
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>
                            {searchBy === "location" && (
                                <div className={MobileSearchCardStyles.editBtn}>
                                    <EditBlueIcon />
                                    <span>Edit</span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <>
                            <SearchBlueIcon />
                            <span
                                className={MobileSearchCardStyles.transporters__mobile_search__source_search_btn__text}
                            >
                                {searchBy === "location" ? (
                                    (selectedSource && (
                                        <>
                                            {sourceSearchLabelKey(selectedSource)}{" "}
                                            <span
                                                className={CloseBtnStyles.btn}
                                                style={{ marginLeft: "20px" }}
                                                onClick={_onClearSrc}
                                            >
                                                <CloseCircleIcon />
                                            </span>
                                        </>
                                    )) ||
                                    "Where is your Loading Point?"
                                ) : (
                                    <>
                                        {nameSearchVal || "Search"}
                                        {nameSearchVal && (
                                            <span
                                                className={CloseBtnStyles.btn}
                                                style={{ position: "absolute", right: "32px" }}
                                                onClick={_onClearName}
                                            >
                                                <CloseCircleIcon height="18" />
                                            </span>
                                        )}
                                    </>
                                )}
                            </span>
                        </>
                    )}
                </div>
                {!isCardMinimized && searchBy === "location" && (
                    <div className={MobileSearchCardStyles.transporters__mobile_search__dest_container}>
                        <div className={MobileSearchCardStyles.transporters__mobile_search__dest_label}>
                            Destination State
                        </div>
                        <div className={MobileSearchCardStyles.dest_search_control}>
                            {topDests.slice(0, 2).map((state) => (
                                <QuickFilterPill
                                    key={state?.state_id}
                                    text={state?.state}
                                    className={MobileSearchCardStyles.dest__quick_filter}
                                    isMobile={true}
                                    isSelected={state?.state_id === (selectedDest?.state_id || selectedDest?.id)}
                                    onSelected={onClickDestQuickFilter}
                                    onDeselected={onDeselectDestSearchBtn}
                                    data={state}
                                    selectedClassName={Styles.selectedStateFilterPill}
                                />
                            ))}
                            <QuickFilterPill
                                prefix={<SearchBlueIcon height={12} width={12} />}
                                className={MobileSearchCardStyles.dest_search_icon_container}
                                prefixClassName={MobileSearchCardStyles.dest_search_icon}
                                onSelected={onClickDestSearchBtn}
                                isMobile={true}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MobileSearchCard;
